import '../../index.css'

const Footer = () => {
    return (

        <footer className="footer">
            <p> App creada en Coderhouse - &copy; Natacha Vergara {new Date().getFullYear()}
            </p>
            
        </footer>

    )
}

export default Footer